exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AddPhoneNumberForm-phoneNumberField-2cwIH {\n    padding: 14px 19px;\n}\n\n.AddPhoneNumberForm-phoneNumberCheckBox-1IcHZ {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    gap: 8px;\n}\n\n.AddPhoneNumberForm-indicationTxt-1KSla {\n    font-size: 16px;\n    line-height: normal;\n    margin: 0;\n}\n\n.AddPhoneNumberForm-indicationTxt-1KSla a,\n.AddPhoneNumberForm-indicationTxt-1KSla a:hover,\n.AddPhoneNumberForm-indicationTxt-1KSla a:focus {\n    color: var(--common-link-color);\n    color: var(--common-link-color);\n}", ""]);

// exports
exports.locals = {
	"phoneNumberField": "AddPhoneNumberForm-phoneNumberField-2cwIH",
	"phoneNumberCheckBox": "AddPhoneNumberForm-phoneNumberCheckBox-1IcHZ",
	"indicationTxt": "AddPhoneNumberForm-indicationTxt-1KSla"
};